import { connect } from 'react-redux';
import { ThemeProviderWithFonts, WebFonts, AmpWebFonts } from 'mm-ui-components';
import { getPalette, getThemeConfiguration } from '../../store/config/config.selectors';
import { AppState } from '../../store/initialStateRegistration';

const mapStateToProps = (state:AppState) => ({
  themeConfiguration: getThemeConfiguration(state),
  palette: getPalette(state),
});

export const Theme = connect(mapStateToProps)(ThemeProviderWithFonts(WebFonts));
export const AmpTheme = connect(mapStateToProps)(ThemeProviderWithFonts(AmpWebFonts));
